import { Flex } from "@acko-tech/building-blocks.ui.common";
import { INudgeTipContent } from "@components/car/journey/types";
import { PrimaryButton } from "@acko-tech/building-blocks.ui.button";
import { MouseEventHandler } from "react";
import TermAndCondition from "@components/common/standAlone/termAndCondition";
import {
  Container,
  Hyperlink,
  PriceText,
  StickyWrapper,
  Wrapper
} from "./styles";

interface CTAProps {
  price: string;
  ctaText?: string;
  clickHandler?: Function;
  isDesktop?: boolean;
  premiumBreakupClickHandler?: Function;
  hidePremiumBreakupCta?: boolean;
  isGstPrice?: boolean;
  showNudgeTip?: boolean;
  policyExpiryNudgeTipContent?: INudgeTipContent | null;
  nudgeTipClickhandler?: Function;
  hidePriceSection?: boolean;
  showtermAndCon?: boolean;
  onTermAndConClick?: MouseEventHandler;
  width?: any;
}

const StickyFooter = ({
  price,
  ctaText,
  clickHandler,
  premiumBreakupClickHandler,
  hidePremiumBreakupCta,
  isGstPrice,
  hidePriceSection,
  showtermAndCon = false,
  onTermAndConClick,
  width
}: CTAProps) => {
  return (
    <StickyWrapper>
      <Wrapper width={width}>
        <Container hidePriceSection={hidePriceSection}>
          {!hidePriceSection && (
            <Flex flexDirection="column">
              <PriceText>
                ₹{price}{" "}
                {!isGstPrice && (
                  <span
                    style={{
                      fontWeight: 400,
                      fontSize: "12px",
                      lineHeight: "16px",

                      color: "#5B5675"
                    }}
                  >
                    + GST
                  </span>
                )}
              </PriceText>
              {!hidePremiumBreakupCta && (
                <Hyperlink
                  onClick={() =>
                    premiumBreakupClickHandler && premiumBreakupClickHandler()
                  }
                >
                  Premium breakup
                </Hyperlink>
              )}
            </Flex>
          )}

          {hidePriceSection && showtermAndCon && (
            <TermAndCondition
              clickHandler={onTermAndConClick}
              style={{ marginTop: "0px", marginRight: "25px" }}
            />
          )}
          <div
            style={{
              width: "224px"
            }}
          >
            <PrimaryButton
              onClick={e => {
                clickHandler && clickHandler(e);
              }}
            >
              {ctaText || "Customise"}
            </PrimaryButton>
          </div>
        </Container>
      </Wrapper>
    </StickyWrapper>
  );
};

export default StickyFooter;
